export const villes1 = [
  {
    slug: "couvreur-joinville-le-pont",
    ville: "Joinville-le-Pont",
    footerLabel: "Couvreur Joinville-le-Pont",
    metaTitle: "Couvreur Joinville-le-Pont — MSC Toitures | Réparation & rénovation de toiture",
    metaDescription:
      "MSC Toitures, couvreur à Joinville-le-Pont (94340) : réparation de toiture, fuite, rénovation, zinguerie, gouttières. Déplacement et devis gratuits depuis Champigny.",
    h1: "Couvreur à Joinville-le-Pont — MSC Toitures",
    intro: [
      "Joinville-le-Pont conjugue un centre-ville dense, des immeubles anciens en bord de Marne et des quartiers pavillonnaires comme celui de Polangis, tout proche de notre showroom. Cette diversité se retrouve sur les toits : toitures en zinc des immeubles, tuiles plates des pavillons, ardoises des maisons meulières.",
      "Depuis notre base de Champigny-sur-Marne — littéralement la commune voisine — MSC Toitures intervient sur toutes ces toitures : réparation, recherche de fuite, rénovation, zinguerie et entretien. Déplacement et devis gratuits à Joinville-le-Pont.",
    ],
    blocks: [
      {
        h2: "Réparation de toiture à Joinville-le-Pont",
        paragraphs: [
          "Tuile déplacée par le vent au-dessus des quais, ardoise fissurée sur une meulière, faitage descellé : nous intervenons sur tous les types de couverture de la commune. Chaque réparation commence par un diagnostic sur place — nous montons voir la toiture avant de chiffrer quoi que ce soit.",
        ],
      },
      {
        h2: "Recherche et réparation de fuite",
        paragraphs: [
          "Sur les toitures joinvillaises, les infiltrations viennent le plus souvent des points singuliers : abergements de cheminée vieillissants, noues encaissées entre deux bâtiments, chéneaux des toitures en zinc. Nous remontons le chemin de l'eau depuis la trace visible jusqu'à son point d'entrée réel, puis nous réparons à la source.",
        ],
      },
      {
        h2: "Rénovation et réfection de toiture",
        paragraphs: [
          "Beaucoup de pavillons de Joinville portent leur couverture d'origine depuis plusieurs décennies. Quand les tuiles deviennent poreuses et que les réparations se multiplient, nous vous aidons à trancher entre rénovation ciblée et réfection complète — avec un avis honnête et un devis détaillé.",
        ],
      },
      {
        h2: "Zinguerie et gouttières",
        paragraphs: [
          "Les toitures en zinc de la commune demandent une zinguerie soignée : soudures, chéneaux, noues, gouttières pendantes ou encaissées. Nous réparons et refaçonnons ces éléments sur mesure, et nous remettons en état les descentes qui laissent couler l'eau sur les façades.",
        ],
      },
      {
        h2: "Entretien et démoussage",
        paragraphs: [
          "La proximité de la Marne et les arbres des quartiers pavillonnaires favorisent la mousse. Un démoussage et un contrôle régulier de la couverture et des gouttières prolongent nettement la vie de votre toiture.",
        ],
      },
    ],
    whyPoints: [
      "Réalisation réelle sur la commune : toiture en bac acier, photo ci-contre",
      "Showroom au 34 boulevard de Polangis à Champigny-sur-Marne, à quelques minutes de Joinville",
      "Déplacement et devis gratuits sur Joinville-le-Pont",
      "Contact direct avec l'entreprise, sans plateforme intermédiaire",
      "Réparation, rénovation, zinguerie et entretien par une même équipe",
    ],
    faq: [
      {
        q: "Intervenez-vous sur les toitures en zinc à Joinville-le-Pont ?",
        a: "Oui. Les immeubles anciens et certaines maisons de la commune ont des toitures ou des éléments en zinc : nous en assurons la réparation, la zinguerie associée (chéneaux, noues, abergements) et l'entretien.",
      },
      {
        q: "Le devis est-il vraiment gratuit à Joinville-le-Pont ?",
        a: "Oui. Le déplacement et le devis sont gratuits à Joinville-le-Pont comme dans tout le Val-de-Marne, et sans engagement de votre part.",
      },
    ],
    photo: "/photos/toiture-bac-acier-joinville-le-pont.webp",
    photoAlt: "Toiture en bac acier réalisée par MSC Toitures à Joinville-le-Pont",
  },
  {
    slug: "couvreur-saint-maur-des-fosses",
    ville: "Saint-Maur-des-Fossés",
    footerLabel: "Couvreur Saint-Maur-des-Fossés",
    metaTitle: "Couvreur Saint-Maur-des-Fossés — MSC Toitures | Toiture, fuite & rénovation",
    metaDescription:
      "MSC Toitures, couvreur à Saint-Maur-des-Fossés (94100) : réparation de toiture, recherche de fuite, réfection, zinguerie, démoussage. Devis gratuit dans le 94.",
    h1: "Couvreur à Saint-Maur-des-Fossés — MSC Toitures",
    intro: [
      "Saint-Maur-des-Fossés est l'une des villes les plus pavillonnaires du Val-de-Marne : de La Varenne-Saint-Hilaire au Parc de Saint-Maur, les toitures de tuiles mécaniques et de tuiles plates s'étendent à perte de vue, souvent à l'ombre de grands arbres. Un cadre de vie agréable — et un environnement qui use les couvertures.",
      "MSC Toitures intervient régulièrement à Saint-Maur-des-Fossés : notre galerie de réalisations présente d'ailleurs une réfection de toiture menée sur la commune. Déplacement et devis gratuits.",
    ],
    blocks: [
      {
        h2: "Réparation de toiture à Saint-Maur-des-Fossés",
        paragraphs: [
          "Sur les pavillons saint-mauriens, les réparations les plus fréquentes concernent les tuiles cassées par les branches ou le gel, les rives exposées au vent et les abergements de cheminée. Nous réparons à l'identique, avec des matériaux adaptés à votre couverture existante.",
        ],
      },
      {
        h2: "Recherche et réparation de fuite",
        paragraphs: [
          "Une tache au plafond d'une chambre sous les combles, une trace d'humidité près de la cheminée : nous localisons l'origine réelle de l'infiltration — rarement au-dessus de la tache — puis nous effectuons la réparation nécessaire. N'attendez pas que l'eau atteigne la charpente.",
        ],
      },
      {
        h2: "Rénovation et réfection de toiture",
        paragraphs: [
          "Nombre de pavillons saint-mauriens des années 1960 à 1980 portent encore leur couverture d'origine. Quand les tuiles deviennent poreuses sur l'ensemble des versants, la réfection — nouvelle couverture, écran de sous-toiture, liteaux neufs — redonne à la maison une protection complète. Nous vous présentons les deux options, rénovation ou réfection, en toute transparence.",
        ],
      },
      {
        h2: "Zinguerie et gouttières",
        paragraphs: [
          "Entre les feuilles d'automne et les mousses, les gouttières de Saint-Maur travaillent dur. Débordements, joints qui fuient, descentes bouchées : nous remettons votre évacuation des eaux pluviales en parfait état de fonctionnement.",
        ],
      },
      {
        h2: "Entretien et démoussage",
        paragraphs: [
          "Les grands arbres qui font le charme de Saint-Maur accélèrent l'encrassement des toitures. Un démoussage adapté au matériau de votre couverture, suivi d'un contrôle des points sensibles, prolonge durablement la vie de votre toit.",
        ],
      },
    ],
    whyPoints: [
      "Réalisation réelle sur la commune : réfection de toiture visible dans notre galerie",
      "Entreprise basée à Champigny-sur-Marne, à proximité immédiate",
      "Déplacement et devis gratuits sur Saint-Maur-des-Fossés",
      "Un interlocuteur unique du diagnostic à la finition",
    ],
    faq: [
      {
        q: "Avez-vous déjà travaillé à Saint-Maur-des-Fossés ?",
        a: "Oui : notre galerie de réalisations présente une réfection de toiture effectuée à Saint-Maur-des-Fossés, avec échafaudage et remplacement de la couverture.",
      },
      {
        q: "Ma toiture est très ombragée par les arbres, faut-il la démousser souvent ?",
        a: "Les toitures ombragées s'encrassent effectivement plus vite. Plutôt qu'une fréquence fixe, nous vous recommandons de nous appeler dès que la mousse forme un tapis visible : le déplacement pour évaluer la situation est gratuit.",
      },
    ],
    photo: "/photos/refection-saint-maur.webp",
    photoAlt: "Réfection de toiture réalisée par MSC Toitures à Saint-Maur-des-Fossés",
  },
  {
    slug: "couvreur-nogent-sur-marne",
    ville: "Nogent-sur-Marne",
    footerLabel: "Couvreur Nogent-sur-Marne",
    metaTitle: "Couvreur Nogent-sur-Marne — MSC Toitures | Toiture, zinguerie & fuites",
    metaDescription:
      "MSC Toitures, couvreur à Nogent-sur-Marne (94130) : réparation de toiture, fuite, zinguerie, rénovation de toitures en zinc et tuiles. Devis gratuit.",
    h1: "Couvreur à Nogent-sur-Marne — MSC Toitures",
    intro: [
      "Entre les immeubles anciens du centre, les pavillons des Baltard et les maisons qui descendent vers les bords de Marne, Nogent-sur-Marne offre un paysage de toitures varié : zinc, ardoise, tuile plate. Autant de couvertures qui demandent un savoir-faire de couvreur-zingueur.",
      "Depuis Champigny-sur-Marne, MSC Toitures intervient dans toute la commune de Nogent : réparation, recherche de fuite, rénovation, zinguerie et entretien. Déplacement et devis gratuits.",
    ],
    blocks: [
      {
        h2: "Réparation de toiture à Nogent-sur-Marne",
        paragraphs: [
          "Ardoise clivée, tuile plate fissurée, élément de zinc soulevé par le vent : nous diagnostiquons sur place et réparons avec les matériaux adaptés au style de votre couverture, dans le respect de l'esthétique nogentaise.",
        ],
      },
      {
        h2: "Recherche et réparation de fuite",
        paragraphs: [
          "Sur les toitures en zinc comme sur les toitures en pente, l'eau emprunte des chemins surprenants. Nous inspectons noues, chéneaux, abergements et raccords avant de réparer à la source de l'infiltration, pas seulement là où la tache apparaît.",
        ],
      },
      {
        h2: "Rénovation et réfection de toiture",
        paragraphs: [
          "Les toitures anciennes de Nogent gagnent souvent à être rénovées avant que les désordres ne s'accumulent. Nous évaluons l'état de la couverture, de la zinguerie et de la charpente visible, puis nous vous proposons la solution proportionnée : rénovation ciblée ou réfection complète.",
        ],
      },
      {
        h2: "Zinguerie et gouttières",
        paragraphs: [
          "La zinguerie est au cœur des toitures nogentaises : gouttières pendantes ou encaissées, chéneaux entre mitoyennetés, noues, entourages de cheminées. Nous façonnons, réparons et soudons ces éléments pour une évacuation de l'eau sans défaut.",
        ],
      },
      {
        h2: "Entretien et démoussage",
        paragraphs: [
          "Mousse sur les versants nord, gouttières encaissées qui retiennent les feuilles : un entretien régulier évite les débordements et les infiltrations. Nous établissons un état clair de votre toiture à chaque passage.",
        ],
      },
    ],
    whyPoints: [
      "Savoir-faire couvreur-zingueur adapté aux toitures en zinc de la commune",
      "Déplacement et devis gratuits sur Nogent-sur-Marne",
      "Entreprise locale établie à Champigny-sur-Marne",
      "Contact téléphonique direct, sans plateforme intermédiaire",
    ],
    faq: [
      {
        q: "Réparez-vous les gouttières encaissées des maisons nogentaises ?",
        a: "Oui. Les gouttières encaissées et les chéneaux font partie de nos travaux de zinguerie courants : recherche de fuite, reprise des joints, refaçonnage si nécessaire.",
      },
      {
        q: "Intervenez-vous sur les toitures en ardoise ?",
        a: "Oui, nous réparons et rénovons les toitures en ardoise comme les toitures en tuile ou en zinc, avec les matériaux adaptés à chaque couverture.",
      },
    ],
    photo: "/photos/zinguerie-apres.webp",
    photoAlt: "Toiture en zinc après travaux de zinguerie par MSC Toitures près de Nogent-sur-Marne",
  },
  {
    slug: "couvreur-le-perreux-sur-marne",
    ville: "Le Perreux-sur-Marne",
    footerLabel: "Couvreur Le Perreux-sur-Marne",
    metaTitle: "Couvreur Le Perreux-sur-Marne — MSC Toitures | Toiture, fuite & démoussage",
    metaDescription:
      "MSC Toitures, couvreur au Perreux-sur-Marne (94170) : réparation de toiture, recherche de fuite, rénovation, zinguerie, démoussage. Déplacement et devis gratuits.",
    h1: "Couvreur au Perreux-sur-Marne — MSC Toitures",
    intro: [
      "Le Perreux-sur-Marne, entre la Marne et le centre de Nogent, mêle maisons meulières, pavillons et petits immeubles. L'humidité des bords de Marne et la végétation généreuse de la commune mettent les toitures à l'épreuve : mousse, gouttières bouchées, zinguerie qui fatigue.",
      "MSC Toitures, installée à Champigny-sur-Marne de l'autre côté de la Marne, intervient sur toute la commune : réparation, fuite, rénovation, zinguerie et entretien. Déplacement et devis gratuits.",
    ],
    blocks: [
      {
        h2: "Réparation de toiture au Perreux-sur-Marne",
        paragraphs: [
          "Tuile cassée, ardoise qui glisse, rive qui se soulève : nous intervenons sur toutes les couvertures de la commune. Chaque réparation débute par un constat sur place, gratuit, et un devis détaillé.",
        ],
      },
      {
        h2: "Recherche et réparation de fuite",
        paragraphs: [
          "Sur les toitures anciennes du Perreux, les infiltrations naissent souvent au niveau des raccords : entourage de cheminée, noue entre deux pans, souche de ventilation. Nous localisons le point d'entrée exact de l'eau avant de réparer durablement.",
        ],
      },
      {
        h2: "Rénovation et réfection de toiture",
        paragraphs: [
          "Les meulières et pavillons anciens de la commune portent parfois des couvertures fatiguées. Nous vous aidons à distinguer ce qui relève d'une rénovation partielle — un versant, la zinguerie — d'une réfection complète, avec un chiffrage clair dans les deux cas.",
        ],
      },
      {
        h2: "Zinguerie et gouttières",
        paragraphs: [
          "Gouttières pendantes qui débordent, chéneaux entre mitoyennetés, noues encaissées : nous réparons et refaçonnons la zinguerie pour que l'eau rejoigne les descentes sans toucher vos façades.",
        ],
      },
      {
        h2: "Entretien et démoussage",
        paragraphs: [
          "La proximité de la Marne favorise l'humidité et donc la mousse. Sur les toitures du Perreux, un démoussage suivi d'un contrôle des gouttières est souvent l'entretien le plus rentable qui soit.",
        ],
      },
    ],
    whyPoints: [
      "Juste de l'autre côté de la Marne : intervention rapide depuis Champigny",
      "Déplacement et devis gratuits au Perreux-sur-Marne",
      "Couvreur-zingueur : couverture et évacuation des eaux traitées ensemble",
      "Conseils honnêtes, sans discours commercial",
    ],
    faq: [
      {
        q: "La mousse revient chaque année sur mon toit au Perreux, est-ce grave ?",
        a: "La mousse récurrente signifie souvent que les tuiles deviennent poreuses. Un démoussage adapté ralentit le phénomène ; lors du diagnostic gratuit, nous vérifions aussi l'état réel de la couverture pour vous dire si un simple entretien suffit.",
      },
      {
        q: "Pouvez-vous réparer une fuite sans refaire toute la toiture ?",
        a: "Dans la grande majorité des cas, oui : une fuite vient d'un défaut localisé — tuile, noue, abergement, gouttière. Nous réparons ce qui doit l'être, et seulement cela.",
      },
    ],
    photo: "/photos/chantier.webp",
    photoAlt: "Chantier de couverture MSC Toitures avec échafaudage au Perreux-sur-Marne et dans le 94",
  },
];
